"use client"

import { create } from "zustand"
import { persist } from "zustand/middleware"

export type KyoboConnectionStatus = "CONSENTED" | "WITHDRAWN" | undefined

interface KyoboConnectionState {
  connectionStatus: KyoboConnectionStatus
  setConnectionStatus: (status: KyoboConnectionStatus) => void
  resetConnectionStatus: () => void
}

export const useKyoboConnectionStore = create<KyoboConnectionState>()(
  persist(
    (set) => ({
      connectionStatus: undefined,
      setConnectionStatus: (status) => set({ connectionStatus: status }),
      resetConnectionStatus: () => set({ connectionStatus: undefined }),
    }),
    {
      name: "kyobo-connection-store",
      partialize: (state) => ({
        connectionStatus: state.connectionStatus,
      }),
      storage: {
        getItem: (name) => {
          const item = sessionStorage.getItem(name)
          return item ? JSON.parse(item) : null
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name)
        },
      },
    },
  ),
)
